import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { DiamMoveDrop, DiamMoveShift } from './DiamMove';
import { DiamPiece } from './DiamPiece';
import { DiamRules } from './DiamRules';
import { DiamState } from './DiamState';
export class DiamMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const drops = this.getListDrops(state);
        const shifts = this.getListShifts(state);
        return drops.concat(shifts);
    }
    getListShifts(state) {
        const shifts = [];
        const shiftSources = this.getShiftSources(state);
        for (const shiftSource of shiftSources) {
            for (const shift of [new DiamMoveShift(shiftSource, 'clockwise'), new DiamMoveShift(shiftSource, 'counterclockwise')]) {
                if (DiamRules.get().shiftHeightValidity(shift, state).isSuccess()) {
                    shifts.push(shift);
                }
            }
        }
        return shifts;
    }
    getListDrops(state) {
        const remainingPieces = this.getRemainingPiecesForCurrentPlayer(state);
        const drops = [];
        for (let x = 0; x < DiamState.WIDTH; x++) {
            for (const piece of remainingPieces) {
                const drop = new DiamMoveDrop(x, piece);
                if (DiamRules.get().dropHeightValidity(drop, state).isSuccess()) {
                    drops.push(drop);
                }
            }
        }
        return drops;
    }
    getRemainingPiecesForCurrentPlayer(state) {
        const pieces = [];
        for (const piece of DiamPiece.PLAYER_PIECES) {
            if (this.currentPlayerCanDropPiece(state, piece)) {
                pieces.push(piece);
            }
        }
        return pieces;
    }
    currentPlayerCanDropPiece(state, piece) {
        return state.getCurrentPlayer() === piece.owner &&
            state.getRemainingPiecesOf(piece) > 0;
    }
    getShiftSources(state) {
        const sources = [];
        const player = state.getCurrentPlayer();
        for (let y = 0; y < DiamState.HEIGHT; y++) {
            for (let x = 0; x < DiamState.WIDTH; x++) {
                if (state.getPieceAtXY(x, y).owner === player) {
                    sources.push(new Coord(x, y));
                }
            }
        }
        return sources;
    }
}
